import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const LunarTracker = () => {
  const [cycle, setCycle] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCycle = async () => {
      try {
        const res = await axios.get(`${API_URL}/lunar-cycle`);
        setCycle(res.data);
      } catch (err) {
        console.error('Failed to fetch lunar cycle', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCycle();
  }, []);

  if (loading) return <div className="content">Loading Lunar Cycle...</div>;

  return (
    <div className="content">
      <h2>Lunar Cycle Tracker</h2>
      <p>Tracking the moon's journey for the next 30 days.</p>
      
      <div className="grid">
        {cycle.map((day: any) => (
          <div key={day.date} className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', filter: 'drop-shadow(0 0 5px var(--gold))' }}>
              {day.emoji}
            </div>
            <h3>{new Date(day.date.replace(/-/g, '/')).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })}</h3>
            <p><strong>{day.phaseName}</strong></p>
            <p style={{ fontSize: '0.9rem', color: 'var(--pale-gold)' }}>
              Illumination: {day.illumination}%<br />
              Age: {Math.round(day.age)} days
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LunarTracker;